module.exports = __webpack_public_path__ + "static/img/main3_4.d5eced55.png";